import React, { createContext, useContext } from "react";
import { useAuthProvider } from "../hooks/useAuthProvider";

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const { user, token, loading, signIn, signOut } = useAuthProvider();

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        loading,
        signIn,
        signOut,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
